// import { useEffect } from "react";
import { useState } from "react";
import ProductsAddRemove from "../../../components/productAddRemove";

const TruncatedTextWithTooltip = ({ text, maxLines }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative w-fit mx-auto">
      {/* Truncated Text */}
      {/* text-[1.8dvw] font-bold duration-700 min-h-[3.5dvh] */}
      <h3
        className={`text-[1.8dvw] duration-700  font-bold text-center cursor-pointer transition-all line-clamp-2 overflow-hidden `}
        onClick={() => setShowTooltip(!showTooltip)}
      >
        {text}
      </h3>

      {/* Tooltip (Full Text) */}
      {showTooltip && (
        <div className="absolute left-1/2 -translate-x-1/2 bottom-full text-[1.4dvh]  border-[0.4dvh] border-main border-solid mb-2 w-max max-w-xs p-2 bg-gray-800/80 text-white font-semibold rounded-[.7dvh] shadow-[1dvh]">
          {text}
        </div>
      )}
    </div>
  );
};
export default function ProductsCard({
  item,
  handleAddToCart,
  cartItems,
  handleDecreaseQty,
  handleIncreaseQty,
}) {
  const matchingItems = cartItems?.product?.filter(
    (cartItem) => cartItem.id === item?.id
  );

  // useEffect(() => {
  //   console.log("Matching Items:", matchingItems);
  // }, [matchingItems]);

  return (
    <>
      <div
        className={` h-[29.2dvw] border-[0.14dvh] rounded-[1.2dvh] border-[#D9D9D9] ${
          matchingItems?.length > 0 ? "bg-[#FAF9F5]" : "bg-[#ffffff]"
        }`}
      >
        <div
          className="w-[12dvw] h-[12dvw]   mx-auto cursor-pointer"
          onClick={() => {
            handleAddToCart(item);
          }}
        >
          <img
            className="w-full h-[7dvh]   object-cover mt-[.5dvh]  border-none mx-auto"
            src={item?.image}
            alt={item?.name}
            loading="lazy"
          />
        </div>
        <div className="my-4 mr-auto w-fit mx-auto px-[1dvw] text-center flex flex-col justify-between">
          <div className="relative group">
            {/* <h3 className="text-[1.8dvw] font-bold duration-700 min-h-[3.5dvh] ">
              {item?.descriptions[0]?.name?.length > 23
                ? `${item.descriptions[0].name.substring(0, 23)}...`
                : item?.descriptions[0]?.name ||
                  (item?.keyword?.length > 23
                    ? `${item.keyword.substring(0, 23)}...`
                    : item?.keyword) ||
                  "No Name"}
            </h3> */}{" "}
            <TruncatedTextWithTooltip
              text={item?.descriptions?.[0]?.name || item?.keyword || "No Name"}
              maxLines={2}
            />
            {/* Tooltip */}
            {/* {item?.descriptions[0]?.name?.length > 23 && (
              <div className="absolute left-0 font-bold  rounded-full top-0 text-[1.2dvw] z-10 hidden w-max max-w-[30dvw] p-[.8dvw] bg-black text-white duration-700 transition ease-in-out delay-150    group-hover:block">
                {item?.descriptions[0]?.name || item?.keyword || "No Name"}
              </div>
            )} */}
          </div>
          <p className="text-[1.5dvw] pb-[0.5dvh] text-gray-700 font-bold">
            {item?.customer_price || "0.00"} SAR
            {/* <span className="text-discountText line-through">
              {item?.discount || "SAR 50"}
            </span> */}
          </p>
          {
            <ProductsAddRemove
              item={item}
              handleIncreaseQty={handleIncreaseQty}
              handleDecreaseQty={handleDecreaseQty}
              cartItems={cartItems}
            />
          }
        </div>
      </div>
    </>
  );
}
